import { createRouter, createWebHashHistory } from "vue-router";
import { useMegStore } from "@/pinia";
import { getToken } from "@/utils/mangeCookie";

export const routerPath = [
  {
    title: "首页",
    path: "/home",
    name: "home",
    component: () => import("@/views/home.vue"),
    icon: "House",
  },
  // 积分活动管理
  {
    title: "积分活动管理",
    path: "/integralActivity",
    name: "integralActivity",
    component: () => import("@/views/integralActivity.vue"),
    icon: "Trophy",
  },
  {
    title: "用户管理",
    path: "/user",
    name: "userManage",
    component: () => import("@/components/layout/empty.vue"),
    icon: "UserFilled",
    children: [
      {
        title: "用户数据",
        path: "/userInfo",
        name: "userInfo",
        component: () => import("@/views/user/userInfo.vue"),
        icon: "User",
      },
      {
        title: "名单设置",
        path: "/user/blacklist",
        name: "userBlacklist",
        component: () => import("@/views/user/userBlacklist.vue"),
        icon: "List",
      },
    ],
  },
  {
    title: "积分管理",
    path: "/integralManage",
    name: "integralManage",
    component: () => import("@/views/integralManage.vue"),
    icon: "Coin",
  },
  {
    title: "会员管理",
    path: "/memberManage",
    name: "memberManage",
    component: () => import("@/views/memberManage.vue"),
    icon: "Medal",
  },
  {
    title: "会员购",
    path: "/memberTicket",
    name: "memberPurchase",
    component: () => import("@/components/layout/empty.vue"),
    icon: "ShoppingBag",
    children: [
      {
        title: "活动",
        path: "/memberTicket/activity",
        name: "memberTicketActivity",
        component: () => import("@/views/memberTicket/activity.vue"),
        icon: "Calendar",
      },
      {
        title: "会员活动配置",
        path: "/memberTicket/activityConfig",
        name: "memberTicketActivityConfig",
        component: () => import("@/views/memberTicket/activityConfig.vue"),
        icon: "Setting",
        meta: { keepAlive: false },
      },
      {
        title: "实体礼物",
        path: "/memberTicket/gift",
        name: "memberGiftActivity",
        component: () => import("@/views/memberTicket/gift.vue"),
        icon: "Present",
        meta: { keepAlive: false },
      },
      {
        title: "礼物领取",
        path: "/memberTicket/giftClaims",
        name: "memberGiftClaims",
        component: () => import("@/views/memberTicket/giftClaims.vue"),
        icon: "Van",
        meta: { keepAlive: false },
      },
      {
        title: "门票",
        path: "/memberTicket/ticket",
        name: "memberTicketList",
        component: () => import("@/views/memberTicket/ticket.vue"),
        icon: "Tickets",
      },
    ],
  },
  {
    title: "Oripa管理",
    path: "/oripa",
    name: "oripaOrderManage",
    component: () => import("@/components/layout/empty.vue"),
    icon: "MagicStick",
    children: [
      {
        title: "抽奖订单",
        path: "/oripa/oripaOrder",
        name: "oripaOrder",
        component: () => import("@/views/oripa/orderList.vue"),
        icon: "ShoppingCart",
      },
      {
        title: "抽奖结果",
        path: "/oripa/oripaOrderResult",
        name: "oripaOrderResult",
        component: () => import("@/views/oripa/orderResult.vue"),
        icon: "DataAnalysis",
      },
      {
        title: "优惠券设置",
        path: "/oripa/couponSet",
        name: "couponSet",
        component: () => import("@/views/oripa/couponSet.vue"),
        icon: "Discount",
      },
    ],
  },
  {
    title: "仓库区管理",
    path: "/warehouse",
    name: "warehouseManage",
    component: () => import("@/components/layout/empty.vue"),
    icon: "Box",
    children: [
      {
        title: "送拍订单",
        path: "/order/consignment",
        name: "consignment",
        component: () => import("@/views/order/consignment.vue"),
        icon: "Sell",
      },
      {
        title: "送评订单",
        path: "/order/evaluation",
        name: "evaluation",
        component: () => import("@/views/order/evaluation.vue"),
        icon: "Stamp",
      },
      {
        title: "送评产品",
        path: "/evaluationProducts",
        name: "evaluationProducts",
        component: () => import("@/views/warehouse/evaluationProducts.vue"),
        icon: "Goods",
      },
    ],
  },
  // 订单管理
  {
    title: "订单管理",
    path: "/order",
    name: "orderManage",
    component: () => import("@/components/layout/empty.vue"),
    icon: "Document",
    children: [
      {
        title: "购买订单",
        path: "/order/buyOrder",
        name: "buyOrder",
        component: () => import("@/views/order/buyOrder.vue"),
        icon: "ShoppingCartFull",
      },
      {
        title: "打印设置",
        path: "/order/printSettings",
        name: "printSettings",
        component: () => import("@/views/order/printSettings.vue"),
        icon: "Printer",
      },
      {
        title: "拍卖",
        path: "/auction/list",
        name: "auction",
        component: () => import("@/views/auction/list.vue"),
        icon: "Stopwatch",
      },
      {
        title: "待收货订单",
        path: "/order/waitShOrder",
        name: "waitShOrder",
        component: () => import("@/views/order/waitShOrder.vue"),
        icon: "TakeawayBox",
      },
      {
        title: "还价信息",
        path: "/bargainInfo",
        name: "bargainInfo",
        component: () => import("@/views/bargainInfo.vue"),
        icon: "PriceTag",
      },
      {
        title: "发货信息",
        path: "/order/sendGoodMessage",
        name: "sendGoodMessage",
        component: () => import("@/views/order/sendGoodMessage.vue"),
        icon: "Van",
      },
      {
        title: "合包路线配置",
        path: "/order/mailRouteConfig",
        name: "mailRouteConfig",
        component: () => import("@/views/order/mailRouteConfig.vue"),
        icon: "Setting",
        meta: { keepAlive: false },
      },
      {
        title: "发货信息商品详情",
        path: "/order/sendGoodDetail",
        name: "sendGoodDetail",
        component: () => import("@/views/order/sendGoodDetail.vue"),
        icon: "Files",
        hidden: true, // 隐藏路由，不在菜单中显示
      },
    ],
  },
  // 保险服务
  {
    title: "保险服务",
    path: "/insurance",
    name: "insuranceManage",
    component: () => import("@/components/layout/empty.vue"),
    icon: "Umbrella",
    children: [
      {
        title: "险种配置",
        path: "/insurance/serviceConfig",
        name: "insuranceServiceConfig",
        component: () => import("@/views/insurance/serviceConfig.vue"),
        icon: "Setting",
        meta: { keepAlive: false },
      },
      {
        title: "保险订单",
        path: "/insurance/orderList",
        name: "insuranceOrderList",
        component: () => import("@/views/insurance/orderList.vue"),
        icon: "Tickets",
        meta: { keepAlive: false },
      },
    ],
  },
  // 通知管理
  {
    title: "通知管理",
    path: "/notification",
    name: "notificationManage",
    component: () => import("@/components/layout/empty.vue"),
    icon: "Bell",
    children: [
      {
        title: "通知管理",
        path: "/notification/manage",
        name: "notificationManageList",
        component: () => import("@/views/notification/notificationManage.vue"),
        icon: "Notification",
      },
      {
        title: "发送消息",
        path: "/sendMessage",
        name: "sendMessage",
        component: () => import("@/views/sendMessage.vue"),
        icon: "Promotion",
      },
    ],
  },
  // 优惠券管理
  {
    title: "优惠券管理",
    path: "/coupon",
    name: "couponManage",
    component: () => import("@/components/layout/empty.vue"),
    icon: "Ticket",
    children: [
      {
        title: "优惠券管理",
        path: "/coupon/manageCoupons",
        name: "manageCoupons",
        component: () => import("@/views/coupon/manageCoupons.vue"),
        icon: "Discount",
      },
      {
        title: "用户优惠券",
        path: "/coupon/userCoupons",
        name: "userCoupons",
        component: () => import("@/views/coupon/userCoupons.vue"),
        icon: "Wallet",
      },
      {
        title: "优惠券策略",
        path: "/coupon/dailyCouponConfig",
        name: "dailyCouponConfig",
        component: () => import("@/views/coupon/dailyCouponConfig.vue"),
        icon: "Calendar",
      },
    ],
  },
  // 轮播图设置
  {
    title: "轮播图设置",
    path: "/loopPicSettings",
    name: "loopPicSettings",
    component: () => import("@/views/loopPic/loopPicSettings.vue"),
    icon: "PictureRounded",
  },
  // 卡牌图鉴
  {
    title: "卡牌图鉴",
    path: "/cardGuide",
    name: "cardGuideManage",
    component: () => import("@/components/layout/empty.vue"),
    icon: "Collection",
    children: [
      {
        title: "分类设置",
        path: "/clazzManage",
        name: "clazzManage",
        component: () => import("@/views/clazzManage.vue"),
        icon: "FolderOpened",
      },
      {
        title: "分类映射",
        path: "/card/categoryMapping",
        name: "categoryMapping",
        component: () => import("@/views/card/categoryMapping.vue"),
        icon: "Connection",
      },
      {
        title: "卡片",
        path: "/card/list",
        name: "card",
        component: () => import("@/views/card/list.vue"),
        icon: "Postcard",
      },
    ],
  },
  // 抽奖机设置
  {
    title: "抽奖机设置",
    path: "/lottery",
    name: "lotteryManage",
    component: () => import("@/components/layout/empty.vue"),
    icon: "TrophyBase",
    children: [
      {
        title: "奖项设置",
        path: "/reward/list",
        name: "reward",
        component: () => import("@/views/reward/list.vue"),
        icon: "GoldMedal",
      },
      {
        title: "抽奖次数发放",
        path: "/reward/sendLotteryTimes",
        name: "sendLotteryTimes",
        component: () => import("@/views/reward/sendLotteryTimes.vue"),
        icon: "Present",
      },
    ],
  },
  // 客服系统
  {
    title: "客服系统",
    path: "/customerService",
    name: "customerServiceManage",
    component: () => import("@/components/layout/empty.vue"),
    icon: "Headset",
    children: [
      {
        title: "工单列表",
        path: "/customerService/ticketList",
        name: "ticketList",
        component: () => import("@/views/customerService/ticketList.vue"),
        icon: "Memo",
      },
      {
        title: "工单详情",
        path: "/customerService/ticketDetail",
        name: "ticketDetail",
        component: () => import("@/views/customerService/ticketDetail.vue"),
        icon: "Document",
        hidden: true, // 隐藏路由，不在菜单中显示
      },
      {
        title: "常用语管理",
        path: "/customerService/commonPhrases",
        name: "commonPhrases",
        component: () => import("@/views/customerService/commonPhrases.vue"),
        icon: "ChatDotSquare",
      },
    ],
  },
];
// 路由配置
const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/user/login.vue"),
  },
  {
    path: "/logon",
    name: "logon",
    component: () => import("@/views/user/logon.vue"),
  },
  {
    path: "/",
    name: "index",
    component: () => import("@/views/index.vue"),
    redirect: "/home",
    children: routerPath,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

function findRouter(path, routers) {
  for (let item of routers) {
    if (item.path === path) {
      return item;
    }
    if (item.children && item.children.length) {
      const found = findRouter(path, item.children);
      if (found) {
        return found;
      }
    }
  }
  return null;
}

const cacheableRoutes = [
  "/order/consignment", // 送拍订单
  "/order/evaluation", // 送评订单
  "/order/buyOrder", // 购买订单
  "/auction/list", // 拍卖
  "/order/waitShOrder", // 待收货订单
  "/order/sendGoodMessage", // 发货信息
  "/bargainInfo", // 还价信息
  "/sendMessage", // 发送消息
  // "/userInfo", // 用户数据
];

const publicPaths = new Set(["/login", "/logon"]);

function getSafeRedirect(redirect) {
  if (
    typeof redirect === "string" &&
    redirect.startsWith("/") &&
    !redirect.startsWith("//") &&
    !publicPaths.has(redirect.split("?")[0])
  ) {
    return redirect;
  }
  return "/home";
}

// 路由守卫
router.beforeEach((to, from, next) => {
  const hasToken = Boolean(getToken());

  if (!hasToken && !publicPaths.has(to.path)) {
    next({
      path: "/login",
      query: { redirect: to.fullPath },
      replace: true,
    });
    return;
  }

  if (hasToken && to.path === "/login") {
    next(getSafeRedirect(to.query.redirect));
    return;
  }

  if (publicPaths.has(to.path)) {
    next();
    return;
  }

  const Store = useMegStore();

  let isHave = Store.tagsList.find((item) => item.path == to.path);
  let activeTags = findRouter(to.path, routerPath);

  if (!isHave && activeTags) {
    // tags中不存在，添加到列表
    Store.setTagsList(activeTags);
  }

  // 无论是否已存在，都要更新激活状态
  if (activeTags) {
    Store.setAcitveTagsName(activeTags.path);
  }

  // 缓存管理逻辑
  if (to.name && cacheableRoutes.includes(to.path)) {
    // 缓存页面组件
    Store.addCachedView(to.name);
    // 同时缓存容器组件（因为这些路由都使用 empty.vue 作为容器）
    Store.addCachedView("EmptyLayout");
  }

  next();
});

export default router;
